import React from "react";

const STATUS_STYLES = {
  draft: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  not_requested: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  pending: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  pending_payment: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  submitted: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  sent: "bg-blue-500/15 text-blue-300 border-blue-500/30",
  quoted: "bg-violet-500/15 text-violet-300 border-violet-500/30",
  reviewing: "bg-violet-500/15 text-violet-300 border-violet-500/30",
  approved: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  confirmed: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  verified: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  consented: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  paid: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  present: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  partial: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  in_progress: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  completed: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
  superseded: "bg-slate-500/15 text-slate-400 border-slate-500/30",
  cancelled: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  rejected: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  failed: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  absent: "bg-rose-500/15 text-rose-300 border-rose-500/30",
};

export function StatusBadge({ status, testId }) {
  const label = String(status || "-").replace(/_/g, " ");
  const cls = STATUS_STYLES[status] || "bg-slate-500/15 text-slate-300 border-slate-500/30";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-mono font-medium uppercase tracking-wide ${cls}`}
    >
      {label}
    </span>
  );
}
